/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CandidateCompany,
    CandidateCompanyFromJSON,
    CandidateCompanyFromJSONTyped,
    CandidateCompanyToJSON,
    Event,
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
    Question,
    QuestionFromJSON,
    QuestionFromJSONTyped,
    QuestionToJSON,
} from './';

/**
 * Detalle de oferta con datos de inscripcion si aplican [P_A_03] [P_A_05] [P_A_12]
 * @export
 * @interface CandidateOffer
 */
export interface CandidateOffer {
    /**
     * 
     * @type {number}
     * @memberof CandidateOffer
     */
    id?: number;
    /**
     * true: viene el company, false: viene el company_name
     * @type {boolean}
     * @memberof CandidateOffer
     */
    displayCompanyName?: boolean;
    /**
     * 
     * @type {CandidateCompany}
     * @memberof CandidateOffer
     */
    company?: CandidateCompany;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    requirements?: string;
    /**
     * 
     * @type {number}
     * @memberof CandidateOffer
     */
    maxJobs?: number;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    dept?: string;
    /**
     * normal, fct, dual
     * @type {string}
     * @memberof CandidateOffer
     */
    modality?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    expireAt?: string;
    /**
     * on_site, semi, remote
     * @type {string}
     * @memberof CandidateOffer
     */
    presence?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOffer
     */
    city?: string;
    /**
     * Id Provincia
     * @type {number}
     * @memberof CandidateOffer
     */
    state?: number;
    /**
     * id tipo de contrato
     * @type {number}
     * @memberof CandidateOffer
     */
    contractType?: number;
    /**
     * duración del trabajo
     * @type {string}
     * @memberof CandidateOffer
     */
    length?: string;
    /**
     * Id de horario
     * @type {number}
     * @memberof CandidateOffer
     */
    schedule?: number;
    /**
     * bruto año, neto al mes, ...
     * @type {string}
     * @memberof CandidateOffer
     */
    salaryType?: string;
    /**
     * 
     * @type {number}
     * @memberof CandidateOffer
     */
    salaryMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CandidateOffer
     */
    salaryMax?: number;
    /**
     * array de strings en json
     * @type {string}
     * @memberof CandidateOffer
     */
    benefits?: string;
    /**
     * otros beneficios
     * @type {string}
     * @memberof CandidateOffer
     */
    benefitsText?: string;
    /**
     * lista de ids
     * @type {Array<number>}
     * @memberof CandidateOffer
     */
    academicPrograms?: Array<number>;
    /**
     * Acepta alumnos que no hayan acabado el ciclo
     * @type {boolean}
     * @memberof CandidateOffer
     */
    acceptUnfinished?: boolean;
    /**
     * El proceso de selección es todo remoto
     * @type {boolean}
     * @memberof CandidateOffer
     */
    isRemoteProcess?: boolean;
    /**
     * 
     * @type {Array<Question>}
     * @memberof CandidateOffer
     */
    questions?: Array<Question>;
    /**
     * unpublished, published, closed
     * @type {string}
     * @memberof CandidateOffer
     */
    status?: string;
    /**
     * esto es para cuando el alumno está inscrito [P_A_12], si no viene null
     * @type {Array<Event>}
     * @memberof CandidateOffer
     */
    events?: Array<Event>;
    /**
     * 
     * @type {Array<object>}
     * @memberof CandidateOffer
     */
    responses?: Array<object>;
    /**
     * Compatibilidad de academic program
     * @type {boolean}
     * @memberof CandidateOffer
     */
    academicMatching?: boolean;
}

export function CandidateOfferFromJSON(json: any): CandidateOffer {
    return CandidateOfferFromJSONTyped(json, false);
}

export function CandidateOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateOffer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'displayCompanyName': !exists(json, 'display_company_name') ? undefined : json['display_company_name'],
        'company': !exists(json, 'company') ? undefined : CandidateCompanyFromJSON(json['company']),
        'companyName': !exists(json, 'company_name') ? undefined : json['company_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'requirements': !exists(json, 'requirements') ? undefined : json['requirements'],
        'maxJobs': !exists(json, 'max_jobs') ? undefined : json['max_jobs'],
        'dept': !exists(json, 'dept') ? undefined : json['dept'],
        'modality': !exists(json, 'modality') ? undefined : json['modality'],
        'externalUrl': !exists(json, 'external_url') ? undefined : json['external_url'],
        'expireAt': !exists(json, 'expire_at') ? undefined : json['expire_at'],
        'presence': !exists(json, 'presence') ? undefined : json['presence'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'contractType': !exists(json, 'contract_type') ? undefined : json['contract_type'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'schedule': !exists(json, 'schedule') ? undefined : json['schedule'],
        'salaryType': !exists(json, 'salary_type') ? undefined : json['salary_type'],
        'salaryMin': !exists(json, 'salary_min') ? undefined : json['salary_min'],
        'salaryMax': !exists(json, 'salary_max') ? undefined : json['salary_max'],
        'benefits': !exists(json, 'benefits') ? undefined : json['benefits'],
        'benefitsText': !exists(json, 'benefits_text') ? undefined : json['benefits_text'],
        'academicPrograms': !exists(json, 'academic_programs') ? undefined : json['academic_programs'],
        'acceptUnfinished': !exists(json, 'accept_unfinished') ? undefined : json['accept_unfinished'],
        'isRemoteProcess': !exists(json, 'is_remote_process') ? undefined : json['is_remote_process'],
        'questions': !exists(json, 'questions') ? undefined : ((json['questions'] as Array<any>).map(QuestionFromJSON)),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(EventFromJSON)),
        'responses': !exists(json, 'responses') ? undefined : json['responses'],
        'academicMatching': !exists(json, 'academic_matching') ? undefined : json['academic_matching'],
    };
}

export function CandidateOfferToJSON(value?: CandidateOffer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'display_company_name': value.displayCompanyName,
        'company': CandidateCompanyToJSON(value.company),
        'company_name': value.companyName,
        'title': value.title,
        'text': value.text,
        'requirements': value.requirements,
        'max_jobs': value.maxJobs,
        'dept': value.dept,
        'modality': value.modality,
        'external_url': value.externalUrl,
        'expire_at': value.expireAt,
        'presence': value.presence,
        'date': value.date,
        'zip': value.zip,
        'city': value.city,
        'state': value.state,
        'contract_type': value.contractType,
        'length': value.length,
        'schedule': value.schedule,
        'salary_type': value.salaryType,
        'salary_min': value.salaryMin,
        'salary_max': value.salaryMax,
        'benefits': value.benefits,
        'benefits_text': value.benefitsText,
        'academic_programs': value.academicPrograms,
        'accept_unfinished': value.acceptUnfinished,
        'is_remote_process': value.isRemoteProcess,
        'questions': value.questions === undefined ? undefined : ((value.questions as Array<any>).map(QuestionToJSON)),
        'status': value.status,
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(EventToJSON)),
        'responses': value.responses,
        'academic_matching': value.academicMatching,
    };
}


